import { ModelBase } from 'store/model-base';

export class DeviceReturnEligible extends ModelBase {
    public static storeName: string = 'deviceReturnEligible';
    public static idAttribute: string = 'deviceId';

    public deviceId: string;
    public returnEligibility: boolean;
    public exchangeEligibility: boolean;
    public warrantyExchangeEligibility: boolean;
}
